var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7501 0.500122V51.75C51.7501 80.0259 74.6439 103 103 103V51.75C102.92 23.3939 80.0259 0.500122 51.7501 0.500122Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499878 0.500122V51.75C0.499878 80.0259 23.3936 103 51.7498 103V51.75C51.7498 23.3939 28.7757 0.500122 0.499878 0.500122Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLeaves);
export default __webpack_public_path__ + "static/media/GrayLeaves.3384a06a29522728119cca620c351a35.svg";
export { ForwardRef as ReactComponent };